const defaults = {
  streamInfo: {
    __typename: 'WorkerStreamInfo',
    streamId: '',
    isAuthenticated: false
  },
  isPending: false
}

const resolvers = {
  Mutation: {
    setWorkerStreamInfo: (_, { streamInfo }, { cache }) => {
      const data = { streamInfo }
      cache.writeData({ data })
      return null
    },
    setAwaitServerResponse: (_, { isPending }, { cache }) => {
      const data = { isPending }
      cache.writeData({ data })
      return null
    }
  }
}

export default {
  defaults,
  resolvers
}
